import React from 'react'

const ClinicPage = () => {
  return (
    <div>ClinicPage</div>
  )
}

export default ClinicPage